export const notifications = {
	state: {
    notificationMessage: "",
    maxTime: 5,
    countdown: 0,
    type: ''
	},
	getters: {
		notificationMessage: state => {
			return state.notificationMessage
		},
		maxTime: state => {
			return state.maxTime
    },
    countdown: state => {
      return state.countdown
    },
    type: state => {
      return state.type
    }
	},
  mutations: {
    showNotification(state, payload){
      state.type = 'warning'
      state.notificationMessage = payload.newMessage
      if(payload.timer !== undefined) state.maxTime = payload.timer
      state.countdown = state.maxTime
    },
    showNotice(state, payload){
      state.type = payload.type
      state.notificationMessage = payload.newMessage
      if(payload.timer !== undefined) state.maxTime = payload.timer
      state.countdown = state.maxTime
    },
    hideNotification(state){
      state.maxTime = 5
      state.countdown = 0
    },
    setCountdown(state, countdown){
      state.countdown = countdown
    }
  }
}

